import TabSurveyAssets from './TabSurveyAssets-compose';

export default TabSurveyAssets;
